/* eslint-disable no-template-curly-in-string */
export const environment: {
  [key: string]: string;
} = {
  BASE_NAME: '${B21_BASE_NAME}',
  ENV: '${ENV}',
  API_URL: '${B21_API_URL}',
  AUDIENCE: '${B21_AUDIENCE}',
  TALENT_URL: '${B21_TALENT_URL}',
  PUBLIC_URL: '${B21_PUBLIC_URL}',
  ULA_URL: '${B21_ULA_URL}',
  ONBOARDING_URL: '${B21_ONBOARDING_URL}',
  UPLOAD_PRESET_DIRECTORY: '${B21_UPLOAD_PRESET_DIRECTORY}',
  CN_HOT_CLOUDNAME: '${B21_CN_HOT_CLOUDNAME}',
  CN_COLD_CLOUDNAME: '${B21_CN_COLD_CLOUDNAME}',
  UPLOAD_PRESET_VIDEO: '${B21_CN_HOT_UPLOAD_PRESET_VIDEO}',
  UPLOAD_PRESET_AUDIO: '${B21_CN_HOT_UPLOAD_PRESET_AUDIO}',
  UPLOAD_PRESET_DEFAULT: '${B21_CN_HOT_UPLOAD_PRESET}',
  UPLOAD_AUTHENTICATED_PRESET: '${B21_CN_HOT_UPLOAD_AUTHENTICATED_PRESET}',
  CLD_DOMAIN: '${B21_CLD_DOMAIN}',
  RECURLY_PUBLIC_KEY: '${B21_RECURLY_PUBLIC_KEY}',
  LAUNCH_DARKLY_CLIENT_ID: '${B21_LAUNCH_DARKLY_ID}',
  GOOGLE_AUTH_CLIENT_ID: '${B21_GOOGLE_AUTH_CLIENT_ID}',
  GOOGLE_MAPS_API_KEY: '${B21_GOOGLE_MAPS_API_KEY}',
  GOOGLE_TAG_MANAGER_ID: '${B21_GOOGLE_TAG_MANAGER_ID}',
  GOOGLE_TAG_MANAGER_ENVIRONMENT_AUTH: '${B21_GOOGLE_TAG_MANAGER_ENVIRONMENT_AUTH}',
  GOOGLE_TAG_MANAGER_ENVIRONMENT_PREVIEW: '${B21_GOOGLE_TAG_MANAGER_ENVIRONMENT_PREVIEW}',
  SENTRY_DSN: '${B21_SENTRY_DSN}',
  B21_RELEASE: '${B21_RELEASE}',
  ALLOWED_COUNTRIES: '${B21_ALLOWED_COUNTRIES}',
  BRAZE_API_KEY: '${B21_BRAZE_API_KEY}',
  BRAZE_API_ENDPOINT: '${B21_BRAZE_API_ENDPOINT}',
  SUBMISSIONS_PAGE_LIMIT: '${B21_SUBMISSIONS_PAGE_LIMIT}',
  AG_GRID_LICENSE: '${B21_AG_GRID_LICENSE}',
  CDN_URL: '${B21_CDN_URL}',
  SURVEY_JS_LICENSE: '${B21_SURVEY_JS_LICENSE}',
  CLOUDFLARE_TURNSTILE_SITE_KEY: '${CLOUDFLARE_TURNSTILE_SITE_KEY}',
  HOTJAR_SITE_ID: '${B21_HOTJAR_SITE_ID}',
  CASTIT_API_URL: '${B21_CASTIT_API_URL}',
  CASTIT_URL: '${B21_CASTIT_URL}',
  FRONT_CHAT_ID: '${B21_FRONT_CHAT_ID}',
  CLD_MEDIA_DOMAIN: '${B21_CLD_MEDIA_DOMAIN}',
};
